module.exports = __webpack_public_path__ + "img/bpa_logo.51ecd111.png";